export const CREDIT_APP_SOURCE_LABELS = {
  admin: 'Added by dealership',
  customer_request: 'Added by customer',
  application: 'Added from financing application',
  multiple: 'Added from multiple sources',
};

export const CREDIT_APP_SECTION_KEYS = ['landlord', 'previous_residential', 'previous_employment'];

export function creditAppSectionHasData(info, sectionKey) {
  if (!info) return false;
  const section = info[sectionKey];
  if (!section) return false;
  return Object.entries(section).some(([key, value]) => (
    key !== 'source' && String(value || '').trim()
  ));
}

export function creditAppSupplementHasAnyData(info) {
  return CREDIT_APP_SECTION_KEYS.some((key) => creditAppSectionHasData(info, key));
}

export function creditAppSectionSource(info, sectionKey) {
  if (!creditAppSectionHasData(info, sectionKey)) return '';
  return info?.[sectionKey]?.source || info?.source || '';
}

export function creditAppHeadingSource(info) {
  const sources = CREDIT_APP_SECTION_KEYS
    .map((key) => creditAppSectionSource(info, key))
    .filter(Boolean);
  const unique = [...new Set(sources)];
  if (unique.length > 1) return 'multiple';
  if (unique.length === 1) return unique[0];
  return info?.source || '';
}

export function creditAppSourcesDiffer(info) {
  return creditAppHeadingSource(info) === 'multiple';
}
